$(document).ready(function() {
    $('#crusade-commander').on('mouseenter', function (e) {
        $(document).bind('mousemove', function (e) {
            var position = e.pageX - ($(this).width()/2);
            if (position < 0) {
            	position = 0;
            } else if (position > 800) {
            	position = 800;
            }
            $('#cloud-1').css('left', (-position / 4) + 'px');
            $('#cloud-1-white').css('left', (-position / 4) + 'px');
            $('#cloud-2').css('right', (position / 5 - 160) + 'px');
            $('#cloud-2-white').css('right', (position / 5 - 160) + 'px');
            $('#cloud-3').css('right', (position / 5 - 160) + 'px');
            $('#cloud-3-white').css('right', (position / 5 - 160) + 'px');
        });
	});
	$('#crusade-commander').on('mouseleave', function (e) {
		$(document).unbind('mousemove');
	});
});


// WEBPACK FOOTER //
// ./src/js/pages/main/cloud.js